import { render, staticRenderFns } from "./CustomerOnboardingLayout.vue?vue&type=template&id=3b2fe76e&"
import script from "./CustomerOnboardingLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerOnboardingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports